/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type for the RowState info, e.g. user groups filtering active
 * @export
 */
export const RowStateInfoTypeConstants = {
    UserGroupsFilterActive: 'UserGroupsFilterActive'
} as const;
export type RowStateInfoTypeConstants = typeof RowStateInfoTypeConstants[keyof typeof RowStateInfoTypeConstants];


export function RowStateInfoTypeConstantsFromJSON(json: any): RowStateInfoTypeConstants {
    return RowStateInfoTypeConstantsFromJSONTyped(json, false);
}

export function RowStateInfoTypeConstantsFromJSONTyped(json: any, ignoreDiscriminator: boolean): RowStateInfoTypeConstants {
    return json as RowStateInfoTypeConstants;
}

export function RowStateInfoTypeConstantsToJSON(value?: RowStateInfoTypeConstants | null): any {
    return value as any;
}

